define("calendar/components/calendar/full-calendar", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/object/computed", "@ember/runloop", "@ember/service", "@ember/utils", "@fullcalendar/core", "@fullcalendar/core/locales/de", "@fullcalendar/core/locales/es", "@fullcalendar/core/locales/fr", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "moment", "perfect-scrollbar", "tracked-built-ins", "calendar/utils/markupBuilders", "later/services/calendar/markup", "later/services/errors", "later/utils/constants", "later/utils/constants/segment-events", "later/utils/fetch", "later/utils/time-format", "later/utils/translation-paths", "shared/components/shared/pre-boarding/survey/index", "shared/utils/hex-to-rgb", "shared/utils/time", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _computed, _runloop, _service, _utils, _core, _de, _es, _fr, _component2, _tracking, _emberConcurrency, _moment, _perfectScrollbar, _trackedBuiltIns, _markupBuilders, _markup, _errors, _constants, _segmentEvents, _fetch, _timeFormat, _translationPaths, _index, _hexToRgb, _time, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _findPostEvent, _addPostHighlight, _resetPostHighlight, _handlePostRightClick, _addNonNoteEvents, _addParentClasses, _createPost, _createCarouselPost, _destroyTimeSlot, _displayCarouselWarning, _displayMonthViewNotes, _generatePostContent, _generateTimeSlotContent, _getDroppedEventDateTime, _getDateWithTimeZone, _handleDrop, _trackBttpDrop, _isValidTimeSlotTarget, _setEventsDisplay, _trackLastClick, _transitionToMultiPostCreation, _transitionToPostCreation, _turnOnCalendarNotes, _updateEventDisplay, _updateNoteTime, _trackSchedulingPost, _updateTimeSlotTime, _updateBttp, _updateSelectPostButtons, _showStoriesAlert;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@fullcalendar/core",0,"@fullcalendar/core/locales/de",0,"@fullcalendar/core/locales/es",0,"@fullcalendar/core/locales/fr",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"moment",0,"perfect-scrollbar",0,"tracked-built-ins",0,"calendar/utils/markupBuilders",0,"later/services/calendar/markup",0,"later/services/errors",0,"later/utils/constants",0,"later/utils/constants/segment-events",0,"later/utils/fetch",0,"later/utils/time-format",0,"later/utils/translation-paths",0,"shared/components/shared/pre-boarding/survey/index",0,"shared/utils/hex-to-rgb",0,"shared/utils/time",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class={{if this.isSelectMode "cCA--board--selectMode"}}>
    {{#if this.showTiktokRefreshModal}}
      <Shared::Credentials::TiktokRefresh
        @closeTiktokRefreshModal={{this.closeTiktokRefreshModal}}
        @tiktokProfile={{this.selectedTiktokProfile}}
      />
    {{/if}}
    {{#if this.showBttpPromoModal}}
      <Calendar::BttpPromo
        @close={{set this "showBttpPromoModal" false}}
        @viewCalendarSettings={{@viewCalendarSettings}}
      />
    {{/if}}
    {{#if this.showNotesPromoModal}}
      <Calendar::NotesPromo
        @close={{set this "showNotesPromoModal" false}}
        @createNewCalendarNote={{this.createNewCalendarNote}}
      />
    {{/if}}
    {{#if @showCalendarSettings}}
      <Calendar::Settings
        @closeModal={{@closeCalendarSettings}}
        @showCalendarNotes={{this.showCalendarNotes}}
        @toggleCalendarNotes={{this.toggleCalendarNotes}}
      />
    {{/if}}
  
    <div
      class={{concat-classes
        (if (and (not this.isSelectMode) this.showFutureTrendsOnCalendar) "cCA--calendar__futureTrends")
        (if (or this.permissions.showInstagramStories this.isSelectMode) "cCA--calendar--instagram")
      }}
      data-test-id="full-calendar"
      {{did-insert this.createCalendar}}
      {{did-update
        this.updateCalendar
        this.currentGroup
        this.profiles
        this.locale.primaryLocale
        this.multipleProfilesSelected
        this.isSelectMode
      }}
      {{did-update this.updateEvents this.cachedData this.permissions}}
      {{on "dblclick" this.handleDoubleClick}}
    >
      <div class={{"cCA--calendar"}} id="calendar">
        {{#if this.shouldShowSocialConnectModal}}
          <Calendar::ConnectSocial @close={{this.closeConnectSocialModal}} />
        {{/if}}
      </div>
  
      {{#unless this.isSelectMode}}
        <Calendar::FutureTrends />
      {{/unless}}
  
      {{#if this.permissions.showInstagramStories}}
        <Calendar::ScheduledStories
          @showAdditionalBanner={{@showAdditionalBanner}}
          @targetDate={{@targetDate}}
          @timelineStories={{@timelineStories}}
        />
      {{/if}}
  
      {{#if this.isSelectMode}}
        <div class="cCA--sharePosts">{{t "calendar.share_posts.calendar_banner"}}</div>
      {{/if}}
  
      <Calendar::ContextMenu
        @copyPost={{this.copyPost}}
        @createNewCalendarNote={{this.createNewCalendarNote}}
        @deletePost={{this.discardPost}}
        @hideContextMenu={{this.hideContextMenu}}
        @left={{this.menuLeft}}
        @post={{this.selectedPost}}
        @selectedProfiles={{@selectedSocialProfiles}}
        @top={{this.menuTop}}
        @visible={{this.displayContextMenu}}
      />
  
    </div>
  
    {{#if this.isOnMonthView}}
      {{#each this.monthViewNotes as |monthViewNotes|}}
        {{! monthViewNotes is a tuple containing [date string, note events array] }}
        {{#let (hash date=(get monthViewNotes "0") notes=(get monthViewNotes "1")) as |notesByDate|}}
          <Shared::Ui::EmberDrop
            @constrainToScrollParent={{false}}
            @constrainToWindow={{true}}
            @contentSelector=".e--collect--drop"
            @hoverOpenDelay={{300}}
            @openOn="click"
            @position="bottom right"
            @target={{concat ".fc-note-" (moment-format notesByDate.date this.dateFormat)}}
            @tetherOptions="25px 0"
            as |emberDrop|
          >
  
            <div class="o--dropWrapper cCA--dropDown cCA--dropDown--lg e--collect--drop">
              <div class="o--dropBody--scroll">
                <p class="u--text--bold u--m__0">{{moment-format notesByDate.date "ddd, MMM DD"}}</p>
                <p class="u--text--sm u--text--light u--m__0">
                  {{notesByDate.notes.length}}
                  {{t "calendar_notes.notes" count=notesByDate.notes.length}}
                </p>
                <ul class="cCA--dropList">
                  {{#each notesByDate.notes as |note|}}
                    <li class="cCA--dropList__li" {{set-background-color note.noteColor}}>
                      <span class="cCA--dropList__icon">
                        {{svg-jar "notes" class="o--icon--xs"}}
                      </span>
                      <p class="cCA--dropList__text">{{note.noteSummary}}</p>
                      <button
                        class="o--btn--block o--btn--sm o--btn--outline"
                        type="button"
                        {{on "click" (fn this.editCalendarNote note.id emberDrop.closeAction)}}
                      >
                        {{t "calendar_notes.view_note"}}
                      </button>
                    </li>
                  {{/each}}
                </ul>
              </div>
            </div>
          </Shared::Ui::EmberDrop>
        {{/let}}
      {{/each}}
    {{/if}}
  
    {{#if this.shouldShowNotesTrialStartModal}}
      <Calendar::NotesTrialStart @closeModal={{this.closeNotesTrialStartModal}} />
    {{/if}}
  
    <Calendar::MultipleBttpTrialModal @onTrialStart={{this.updateEvents}} />
  
    {{#if this.showSharePostsModal}}
      <Calendar::SharePosts
        @closeModal={{set this "showSharePostsModal" false}}
        @createSharePostLink={{this.createSharePostLink}}
        @selectedPosts={{this.selectedPosts}}
        @shareId={{this.shareId}}
        @sharePostExpiresTime={{this.sharePostExpiresTime}}
        @sharePostUrl={{this.sharePostUrl}}
      />
    {{/if}}
  </div>
  
  {{#if this.bttpDropdownOpen}}
    <div class="fc-bttp-dropdown__backdrop" data-test-id="bttp-dropdown-backdrop" {{on "click" this.closeBttpDropdown}} />
    <div
      aria-label={{t "bttp.calendar_dropdown.title"}}
      aria-modal="true"
      class="fc-bttp-dropdown"
      data-test-id="bttp-dropdown"
      role="dialog"
      style={{this.bttpDropdownStyle}}
      {{did-update this.closeBttpDropdown this.profiles}}
      {{on "keydown" this.handleBttpDropdownKeydown}}
    >
      <h2 class="u--text--md fc-bttp-dropdown__title">
        {{t "bttp.calendar_dropdown.title"}}
        <span class="u--flex" data-test-id="bttp-dropdown-popover">
          <EmberPopover @hideOn="mouseleave" @popperContainer="body" @side="top" data-test-id="bttp-dropdown-tooltip">
            {{html-safe (t "bttp.calendar_dropdown.tooltip")}}
          </EmberPopover>
          {{svg-jar "info" class="o--icon--sm"}}
        </span>
      </h2>
      <ul class="fc-bttp-dropdown__list" data-test-id="bttp-dropdown-list">
        {{#each this.bttpDropdownItems as |bttp index|}}
          <li class="fc-bttp-dropdown__item--wrapper" data-test-id="bttp-dropdown-item-{{index}}">
            <button
              class="fc-bttp-dropdown__item"
              data-test-id="bttp-dropdown-item-btn"
              type="button"
              {{on "click" (fn this.scheduleFromBttp bttp bttp.date)}}
            >
              <div class="fc-bttp-dropdown__item--avatar">
                <Shared::ProfileAvatar
                  @showOutline={{true}}
                  @showPlatform={{true}}
                  @socialProfile={{bttp.socialProfile}}
                  class={{concat-classes "cCA--user" "u--m__r__xs"}}
                />
  
                <span class="u--text--base u--ellipsis">
                  {{bttp.profileName}}
                </span>
              </div>
  
              <div class="fc-bttp-dropdown__item--details">
                <div class="fc-bttp-dropdown__item--schedulePost">
                  <span class="u--text--sm u--text--bold">
                    {{t "bttp.calendar_dropdown.schedule_post"}}
                  </span>
                  {{svg-jar "arrow-right" class="o--icon--xs"}}
                </div>
  
                <span
                  class="fc-bttp-dropdown__item--time u--text--sm u--text--light u--ellipsis"
                  data-test-id="bttp-dropdown-item-formatted-time"
                >
                  {{format-bttp bttp.startMins}}
                </span>
              </div>
            </button>
          </li>
        {{/each}}
      </ul>
    </div>
  {{/if}}
  */
  {
    "id": "JwZY2Hsb",
    "block": "[[[10,0],[15,0,[52,[30,0,[\"isSelectMode\"]],\"cCA--board--selectMode\"]],[12],[1,\"\\n\"],[41,[30,0,[\"showTiktokRefreshModal\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@closeTiktokRefreshModal\",\"@tiktokProfile\"],[[30,0,[\"closeTiktokRefreshModal\"]],[30,0,[\"selectedTiktokProfile\"]]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showBttpPromoModal\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@close\",\"@viewCalendarSettings\"],[[28,[37,3],[[30,0],\"showBttpPromoModal\",false],null],[30,1]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showNotesPromoModal\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@close\",\"@createNewCalendarNote\"],[[28,[37,3],[[30,0],\"showNotesPromoModal\",false],null],[30,0,[\"createNewCalendarNote\"]]]],null],[1,\"\\n\"]],[]],null],[41,[30,2],[[[1,\"    \"],[8,[39,5],null,[[\"@closeModal\",\"@showCalendarNotes\",\"@toggleCalendarNotes\"],[[30,3],[30,0,[\"showCalendarNotes\"]],[30,0,[\"toggleCalendarNotes\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[11,0],[16,0,[28,[37,6],[[52,[28,[37,7],[[28,[37,8],[[30,0,[\"isSelectMode\"]]],null],[30,0,[\"showFutureTrendsOnCalendar\"]]],null],\"cCA--calendar__futureTrends\"],[52,[28,[37,9],[[30,0,[\"permissions\",\"showInstagramStories\"]],[30,0,[\"isSelectMode\"]]],null],\"cCA--calendar--instagram\"]],null]],[24,\"data-test-id\",\"full-calendar\"],[4,[38,10],[[30,0,[\"createCalendar\"]]],null],[4,[38,11],[[30,0,[\"updateCalendar\"]],[30,0,[\"currentGroup\"]],[30,0,[\"profiles\"]],[30,0,[\"locale\",\"primaryLocale\"]],[30,0,[\"multipleProfilesSelected\"]],[30,0,[\"isSelectMode\"]]],null],[4,[38,11],[[30,0,[\"updateEvents\"]],[30,0,[\"cachedData\"]],[30,0,[\"permissions\"]]],null],[4,[38,12],[\"dblclick\",[30,0,[\"handleDoubleClick\"]]],null],[12],[1,\"\\n    \"],[10,0],[14,0,\"cCA--calendar\"],[14,1,\"calendar\"],[12],[1,\"\\n\"],[41,[30,0,[\"shouldShowSocialConnectModal\"]],[[[1,\"        \"],[8,[39,13],null,[[\"@close\"],[[30,0,[\"closeConnectSocialModal\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"isSelectMode\"]]],[[[1,\"      \"],[8,[39,15],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"permissions\",\"showInstagramStories\"]],[[[1,\"      \"],[8,[39,16],null,[[\"@showAdditionalBanner\",\"@targetDate\",\"@timelineStories\"],[[30,4],[30,5],[30,6]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isSelectMode\"]],[[[1,\"      \"],[10,0],[14,0,\"cCA--sharePosts\"],[12],[1,[28,[35,17],[\"calendar.share_posts.calendar_banner\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,18],null,[[\"@copyPost\",\"@createNewCalendarNote\",\"@deletePost\",\"@hideContextMenu\",\"@left\",\"@post\",\"@selectedProfiles\",\"@top\",\"@visible\"],[[30,0,[\"copyPost\"]],[30,0,[\"createNewCalendarNote\"]],[30,0,[\"discardPost\"]],[30,0,[\"hideContextMenu\"]],[30,0,[\"menuLeft\"]],[30,0,[\"selectedPost\"]],[30,7],[30,0,[\"menuTop\"]],[30,0,[\"displayContextMenu\"]]]],null],[1,\"\\n\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isOnMonthView\"]],[[[42,[28,[37,20],[[28,[37,20],[[30,0,[\"monthViewNotes\"]]],null]],null],null,[[[44,[[28,[37,22],null,[[\"date\",\"notes\"],[[28,[37,23],[[30,8],\"0\"],null],[28,[37,23],[[30,8],\"1\"],null]]]]],[[[1,\"        \"],[8,[39,24],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@hoverOpenDelay\",\"@openOn\",\"@position\",\"@target\",\"@tetherOptions\"],[false,true,\".e--collect--drop\",300,\"click\",\"bottom right\",[28,[37,25],[\".fc-note-\",[28,[37,26],[[30,9,[\"date\"]],[30,0,[\"dateFormat\"]]],null]],null],\"25px 0\"]],[[\"default\"],[[[[1,\"\\n\\n          \"],[10,0],[14,0,\"o--dropWrapper cCA--dropDown cCA--dropDown--lg e--collect--drop\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--dropBody--scroll\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--text--bold u--m__0\"],[12],[1,[28,[35,26],[[30,9,[\"date\"]],\"ddd, MMM DD\"],null]],[13],[1,\"\\n              \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__0\"],[12],[1,\"\\n                \"],[1,[30,9,[\"notes\",\"length\"]]],[1,\"\\n                \"],[1,[28,[35,17],[\"calendar_notes.notes\"],[[\"count\"],[[30,9,[\"notes\",\"length\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"ul\"],[14,0,\"cCA--dropList\"],[12],[1,\"\\n\"],[42,[28,[37,20],[[28,[37,20],[[30,9,[\"notes\"]]],null]],null],null,[[[1,\"                  \"],[11,\"li\"],[24,0,\"cCA--dropList__li\"],[4,[38,27],[[30,11,[\"noteColor\"]]],null],[12],[1,\"\\n                    \"],[10,1],[14,0,\"cCA--dropList__icon\"],[12],[1,\"\\n                      \"],[1,[28,[35,28],[\"notes\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n                    \"],[13],[1,\"\\n                    \"],[10,2],[14,0,\"cCA--dropList__text\"],[12],[1,[30,11,[\"noteSummary\"]]],[13],[1,\"\\n                    \"],[11,\"button\"],[24,0,\"o--btn--block o--btn--sm o--btn--outline\"],[24,4,\"button\"],[4,[38,12],[\"click\",[28,[37,29],[[30,0,[\"editCalendarNote\"]],[30,11,[\"id\"]],[30,10,[\"closeAction\"]]],null]],null],[12],[1,\"\\n                      \"],[1,[28,[35,17],[\"calendar_notes.view_note\"],null]],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[11]],null],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[10]]]]],[1,\"\\n\"]],[9]]]],[8]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowNotesTrialStartModal\"]],[[[1,\"    \"],[8,[39,30],null,[[\"@closeModal\"],[[30,0,[\"closeNotesTrialStartModal\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,31],null,[[\"@onTrialStart\"],[[30,0,[\"updateEvents\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showSharePostsModal\"]],[[[1,\"    \"],[8,[39,32],null,[[\"@closeModal\",\"@createSharePostLink\",\"@selectedPosts\",\"@shareId\",\"@sharePostExpiresTime\",\"@sharePostUrl\"],[[28,[37,3],[[30,0],\"showSharePostsModal\",false],null],[30,0,[\"createSharePostLink\"]],[30,0,[\"selectedPosts\"]],[30,0,[\"shareId\"]],[30,0,[\"sharePostExpiresTime\"]],[30,0,[\"sharePostUrl\"]]]],null],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[41,[30,0,[\"bttpDropdownOpen\"]],[[[1,\"  \"],[11,0],[24,0,\"fc-bttp-dropdown__backdrop\"],[24,\"data-test-id\",\"bttp-dropdown-backdrop\"],[4,[38,12],[\"click\",[30,0,[\"closeBttpDropdown\"]]],null],[12],[13],[1,\"\\n  \"],[11,0],[16,\"aria-label\",[28,[37,17],[\"bttp.calendar_dropdown.title\"],null]],[24,\"aria-modal\",\"true\"],[24,0,\"fc-bttp-dropdown\"],[24,\"data-test-id\",\"bttp-dropdown\"],[24,\"role\",\"dialog\"],[16,5,[30,0,[\"bttpDropdownStyle\"]]],[4,[38,11],[[30,0,[\"closeBttpDropdown\"]],[30,0,[\"profiles\"]]],null],[4,[38,12],[\"keydown\",[30,0,[\"handleBttpDropdownKeydown\"]]],null],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"u--text--md fc-bttp-dropdown__title\"],[12],[1,\"\\n      \"],[1,[28,[35,17],[\"bttp.calendar_dropdown.title\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"u--flex\"],[14,\"data-test-id\",\"bttp-dropdown-popover\"],[12],[1,\"\\n        \"],[8,[39,33],[[24,\"data-test-id\",\"bttp-dropdown-tooltip\"]],[[\"@hideOn\",\"@popperContainer\",\"@side\"],[\"mouseleave\",\"body\",\"top\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,34],[[28,[37,17],[\"bttp.calendar_dropdown.tooltip\"],null]],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[1,[28,[35,28],[\"info\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"fc-bttp-dropdown__list\"],[14,\"data-test-id\",\"bttp-dropdown-list\"],[12],[1,\"\\n\"],[42,[28,[37,20],[[28,[37,20],[[30,0,[\"bttpDropdownItems\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"fc-bttp-dropdown__item--wrapper\"],[15,\"data-test-id\",[29,[\"bttp-dropdown-item-\",[30,13]]]],[12],[1,\"\\n          \"],[11,\"button\"],[24,0,\"fc-bttp-dropdown__item\"],[24,\"data-test-id\",\"bttp-dropdown-item-btn\"],[24,4,\"button\"],[4,[38,12],[\"click\",[28,[37,29],[[30,0,[\"scheduleFromBttp\"]],[30,12],[30,12,[\"date\"]]],null]],null],[12],[1,\"\\n            \"],[10,0],[14,0,\"fc-bttp-dropdown__item--avatar\"],[12],[1,\"\\n              \"],[8,[39,35],[[16,0,[28,[37,6],[\"cCA--user\",\"u--m__r__xs\"],null]]],[[\"@showOutline\",\"@showPlatform\",\"@socialProfile\"],[true,true,[30,12,[\"socialProfile\"]]]],null],[1,\"\\n\\n              \"],[10,1],[14,0,\"u--text--base u--ellipsis\"],[12],[1,\"\\n                \"],[1,[30,12,[\"profileName\"]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"fc-bttp-dropdown__item--details\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"fc-bttp-dropdown__item--schedulePost\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--text--sm u--text--bold\"],[12],[1,\"\\n                  \"],[1,[28,[35,17],[\"bttp.calendar_dropdown.schedule_post\"],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[1,[28,[35,28],[\"arrow-right\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[10,1],[14,0,\"fc-bttp-dropdown__item--time u--text--sm u--text--light u--ellipsis\"],[14,\"data-test-id\",\"bttp-dropdown-item-formatted-time\"],[12],[1,\"\\n                \"],[1,[28,[35,36],[[30,12,[\"startMins\"]]],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[12,13]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@viewCalendarSettings\",\"@showCalendarSettings\",\"@closeCalendarSettings\",\"@showAdditionalBanner\",\"@targetDate\",\"@timelineStories\",\"@selectedSocialProfiles\",\"monthViewNotes\",\"notesByDate\",\"emberDrop\",\"note\",\"bttp\",\"index\"],false,[\"if\",\"shared/credentials/tiktok-refresh\",\"calendar/bttp-promo\",\"set\",\"calendar/notes-promo\",\"calendar/settings\",\"concat-classes\",\"and\",\"not\",\"or\",\"did-insert\",\"did-update\",\"on\",\"calendar/connect-social\",\"unless\",\"calendar/future-trends\",\"calendar/scheduled-stories\",\"t\",\"calendar/context-menu\",\"each\",\"-track-array\",\"let\",\"hash\",\"get\",\"shared/ui/ember-drop\",\"concat\",\"moment-format\",\"set-background-color\",\"svg-jar\",\"fn\",\"calendar/notes-trial-start\",\"calendar/multiple-bttp-trial-modal\",\"calendar/share-posts\",\"ember-popover\",\"html-safe\",\"shared/profile-avatar\",\"format-bttp\"]]",
    "moduleName": "calendar/components/calendar/full-calendar.hbs",
    "isStrictMode": false
  });
  const {
    NOTE,
    POST,
    BTTP,
    BTTP_PROMO,
    TIME_SLOT,
    NOTES_PROMO
  } = _constants.CALENDAR_EVENT_TYPES;
  const {
    DEFAULT,
    SELECT
  } = _constants.CALENDAR_TYPES;
  const {
    MONTH,
    WEEK
  } = _constants.CALENDAR_VIEW_TYPES;
  const CALENDAR_NOTE_STATES = {
    ON: 'on',
    OFF: 'off'
  };
  let FullCalendarComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), _dec2 = (0, _service.inject)('calendar/config'), _dec3 = (0, _service.inject)('calendar/events'), _dec4 = (0, _service.inject)('calendar/markup'), _dec5 = (0, _service.inject)('note'), _dec6 = (0, _service.inject)('schedule/calendar/time-slot'), _dec7 = (0, _service.inject)('schedule/post'), _dec8 = (0, _service.inject)('schedule/posts-pending-approval'), _dec9 = (0, _computed.readOnly)('auth.currentAccount'), _dec10 = (0, _computed.readOnly)('account.canCarousel'), _dec11 = (0, _computed.readOnly)('account.canInstagramStories'), _dec12 = (0, _computed.readOnly)('calendarConfig.calendarView'), _dec13 = (0, _computed.readOnly)('account.canCalendarNotes'), _dec14 = (0, _computed.readOnly)('selectedSocialProfiles.firstProfile'), _dec15 = (0, _computed.readOnly)('selectedSocialProfiles.hasMultipleSelected'), _dec16 = (0, _computed.readOnly)('auth.currentGroup'), _dec17 = (0, _computed.readOnly)('userConfig.currentTimeZone.identifier'), (_class = (_findPostEvent = /*#__PURE__*/new WeakSet(), _addPostHighlight = /*#__PURE__*/new WeakSet(), _resetPostHighlight = /*#__PURE__*/new WeakSet(), _handlePostRightClick = /*#__PURE__*/new WeakSet(), _addNonNoteEvents = /*#__PURE__*/new WeakSet(), _addParentClasses = /*#__PURE__*/new WeakSet(), _createPost = /*#__PURE__*/new WeakSet(), _createCarouselPost = /*#__PURE__*/new WeakSet(), _destroyTimeSlot = /*#__PURE__*/new WeakSet(), _displayCarouselWarning = /*#__PURE__*/new WeakSet(), _displayMonthViewNotes = /*#__PURE__*/new WeakSet(), _generatePostContent = /*#__PURE__*/new WeakSet(), _generateTimeSlotContent = /*#__PURE__*/new WeakSet(), _getDroppedEventDateTime = /*#__PURE__*/new WeakSet(), _getDateWithTimeZone = /*#__PURE__*/new WeakSet(), _handleDrop = /*#__PURE__*/new WeakMap(), _trackBttpDrop = /*#__PURE__*/new WeakSet(), _isValidTimeSlotTarget = /*#__PURE__*/new WeakSet(), _setEventsDisplay = /*#__PURE__*/new WeakSet(), _trackLastClick = /*#__PURE__*/new WeakSet(), _transitionToMultiPostCreation = /*#__PURE__*/new WeakSet(), _transitionToPostCreation = /*#__PURE__*/new WeakSet(), _turnOnCalendarNotes = /*#__PURE__*/new WeakSet(), _updateEventDisplay = /*#__PURE__*/new WeakSet(), _updateNoteTime = /*#__PURE__*/new WeakSet(), _trackSchedulingPost = /*#__PURE__*/new WeakSet(), _updateTimeSlotTime = /*#__PURE__*/new WeakSet(), _updateBttp = /*#__PURE__*/new WeakSet(), _updateSelectPostButtons = /*#__PURE__*/new WeakSet(), _showStoriesAlert = /*#__PURE__*/new WeakSet(), class FullCalendarComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _showStoriesAlert);
      _classPrivateMethodInitSpec(this, _updateSelectPostButtons);
      _classPrivateMethodInitSpec(this, _updateBttp);
      _classPrivateMethodInitSpec(this, _updateTimeSlotTime);
      _classPrivateMethodInitSpec(this, _trackSchedulingPost);
      _classPrivateMethodInitSpec(this, _updateNoteTime);
      // Note: Do not display non-post events on month view
      _classPrivateMethodInitSpec(this, _updateEventDisplay);
      _classPrivateMethodInitSpec(this, _turnOnCalendarNotes);
      _classPrivateMethodInitSpec(this, _transitionToPostCreation);
      _classPrivateMethodInitSpec(this, _transitionToMultiPostCreation);
      // Note: Set last clicked target/view/date for usage with 'on-calendar-double-click' modifier
      _classPrivateMethodInitSpec(this, _trackLastClick);
      // Note: Set display for non-post events
      _classPrivateMethodInitSpec(this, _setEventsDisplay);
      _classPrivateMethodInitSpec(this, _isValidTimeSlotTarget);
      _classPrivateMethodInitSpec(this, _trackBttpDrop);
      _classPrivateMethodInitSpec(this, _getDateWithTimeZone);
      _classPrivateMethodInitSpec(this, _getDroppedEventDateTime);
      _classPrivateMethodInitSpec(this, _generateTimeSlotContent);
      _classPrivateMethodInitSpec(this, _generatePostContent);
      // Note: Add and remove note markup on month view, this is handled manually as fullcalendar content injection methods do not trigger on event/view/date changes
      _classPrivateMethodInitSpec(this, _displayMonthViewNotes);
      _classPrivateMethodInitSpec(this, _displayCarouselWarning);
      _classPrivateMethodInitSpec(this, _destroyTimeSlot);
      _classPrivateMethodInitSpec(this, _createCarouselPost);
      _classPrivateMethodInitSpec(this, _createPost);
      _classPrivateMethodInitSpec(this, _addParentClasses);
      _classPrivateMethodInitSpec(this, _addNonNoteEvents);
      _classPrivateMethodInitSpec(this, _handlePostRightClick);
      _classPrivateMethodInitSpec(this, _resetPostHighlight);
      _classPrivateMethodInitSpec(this, _addPostHighlight);
      // Helper method to find a post event from a clicked element
      _classPrivateMethodInitSpec(this, _findPostEvent);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "bttp", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "cache", _descriptor5, this);
      _initializerDefineProperty(this, "intl", _descriptor6, this);
      _initializerDefineProperty(this, "onboarding", _descriptor7, this);
      _initializerDefineProperty(this, "locale", _descriptor8, this);
      _initializerDefineProperty(this, "router", _descriptor9, this);
      _initializerDefineProperty(this, "calendarConfig", _descriptor10, this);
      _initializerDefineProperty(this, "calendarEvents", _descriptor11, this);
      _initializerDefineProperty(this, "calendarMarkup", _descriptor12, this);
      _initializerDefineProperty(this, "calendarNote", _descriptor13, this);
      _initializerDefineProperty(this, "calendarTimeSlot", _descriptor14, this);
      // eslint-disable-next-line ember/no-unused-services -- self.schedulePost is used
      _initializerDefineProperty(this, "schedulePost", _descriptor15, this);
      _initializerDefineProperty(this, "postsPendingApproval", _descriptor16, this);
      _initializerDefineProperty(this, "segment", _descriptor17, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor18, this);
      _initializerDefineProperty(this, "store", _descriptor19, this);
      // eslint-disable-next-line ember/no-unused-services -- self.subscriptions is used
      _initializerDefineProperty(this, "subscriptions", _descriptor20, this);
      _initializerDefineProperty(this, "userConfig", _descriptor21, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor22, this);
      _initializerDefineProperty(this, "displayContextMenu", _descriptor23, this);
      _initializerDefineProperty(this, "menuLeft", _descriptor24, this);
      _initializerDefineProperty(this, "menuTop", _descriptor25, this);
      _initializerDefineProperty(this, "selectedNoteDate", _descriptor26, this);
      _initializerDefineProperty(this, "notesByDate", _descriptor27, this);
      _initializerDefineProperty(this, "selectedTiktokProfile", _descriptor28, this);
      _initializerDefineProperty(this, "showBttpPromoModal", _descriptor29, this);
      _initializerDefineProperty(this, "showNotesPromoModal", _descriptor30, this);
      _initializerDefineProperty(this, "showCalendarNotes", _descriptor31, this);
      _initializerDefineProperty(this, "showConnectSocialModal", _descriptor32, this);
      _initializerDefineProperty(this, "showTiktokRefreshModal", _descriptor33, this);
      _initializerDefineProperty(this, "shouldShowNotesTrialStartModal", _descriptor34, this);
      _initializerDefineProperty(this, "isSelectMode", _descriptor35, this);
      _initializerDefineProperty(this, "selectedPosts", _descriptor36, this);
      _initializerDefineProperty(this, "shareId", _descriptor37, this);
      _initializerDefineProperty(this, "sharePostUrl", _descriptor38, this);
      _initializerDefineProperty(this, "sharePostExpiresTime", _descriptor39, this);
      _initializerDefineProperty(this, "showSharePostsModal", _descriptor40, this);
      _initializerDefineProperty(this, "selectedPost", _descriptor41, this);
      _initializerDefineProperty(this, "selectedPostElement", _descriptor42, this);
      _initializerDefineProperty(this, "bttpTooltipRoot", _descriptor43, this);
      _initializerDefineProperty(this, "bttpDropdownOpen", _descriptor44, this);
      _initializerDefineProperty(this, "bttpDropdownItems", _descriptor45, this);
      _initializerDefineProperty(this, "bttpDropdownStyleObj", _descriptor46, this);
      _defineProperty(this, "calendarNotesCacheKey", 'showCalendarNotes');
      _defineProperty(this, "dateFormat", 'YYYY-MM-DD');
      _defineProperty(this, "lastClickInfo", null);
      _defineProperty(this, "storiesAlertKey", 'hasSeenSharePostsStoriesAlert');
      _defineProperty(this, "shareSvg", `<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4071 8.18288C10.6185 8.18288 9.89568 8.51144 9.43568 9.10287L6.08425 7.46001C6.14996 7.26287 6.14996 7.06573 6.14996 6.9343C6.14996 6.80287 6.14996 6.54002 6.08425 6.40859L9.43568 4.76573C9.89568 5.29144 10.6185 5.68573 11.4071 5.68573C12.8528 5.68573 14.0357 4.50288 14.0357 3.05716C14.0357 1.61145 12.8528 0.428589 11.4071 0.428589C9.96139 0.428589 8.77854 1.61145 8.77854 3.05716C8.77854 3.25431 8.77854 3.45145 8.84425 3.58288L5.49282 5.22573C5.03282 4.70002 4.30996 4.30573 3.52139 4.30573C2.07568 4.30573 0.892822 5.48859 0.892822 6.9343C0.892822 8.38001 2.07568 9.56287 3.52139 9.56287C4.30996 9.56287 5.03282 9.2343 5.49282 8.64287L8.84425 10.2857C8.77854 10.4829 8.77854 10.68 8.77854 10.8114C8.77854 12.2572 9.96139 13.44 11.4071 13.44C12.8528 13.44 14.0357 12.2572 14.0357 10.8114C14.0357 9.36573 12.8528 8.18288 11.4071 8.18288ZM11.4071 1.61145C12.13 1.61145 12.7214 2.20287 12.7214 2.92573C12.7214 3.64859 12.13 4.24002 11.4071 4.24002C10.6843 4.24002 10.0928 3.64859 10.0928 2.92573C10.0928 2.20287 10.6843 1.61145 11.4071 1.61145ZM3.52139 8.18288C2.79854 8.18288 2.20711 7.59145 2.20711 6.86859C2.20711 6.14573 2.79854 5.5543 3.52139 5.5543C4.24425 5.5543 4.83568 6.14573 4.83568 6.86859C4.83568 7.59145 4.24425 8.18288 3.52139 8.18288ZM11.4071 12.1257C10.6843 12.1257 10.0928 11.5343 10.0928 10.8114C10.0928 10.0886 10.6843 9.49716 11.4071 9.49716C12.13 9.49716 12.7214 10.0886 12.7214 10.8114C12.7214 11.5343 12.13 12.1257 11.4071 12.1257Z" fill="#323B43"/></svg>`);
      _initializerDefineProperty(this, "account", _descriptor47, this);
      _initializerDefineProperty(this, "canCarousel", _descriptor48, this);
      _initializerDefineProperty(this, "canInstagramStories", _descriptor49, this);
      _initializerDefineProperty(this, "calendarView", _descriptor50, this);
      _initializerDefineProperty(this, "canCalendarNotes", _descriptor51, this);
      _initializerDefineProperty(this, "socialProfile", _descriptor52, this);
      _initializerDefineProperty(this, "multipleProfilesSelected", _descriptor53, this);
      _initializerDefineProperty(this, "currentGroup", _descriptor54, this);
      _initializerDefineProperty(this, "timeZoneIdentifier", _descriptor55, this);
      _defineProperty(this, "onClickCreateLink", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.createSharePostLink.perform();
          this.showSharePostsModal = true;
          this.segment.track(_segmentEvents.SegmentEventTypes.ClickedCreateLink, {
            number_of_posts: this.selectedPosts.size,
            link: this.sharePostUrl || ''
          });
        }
      }), null, "onClickCreateLink", null));
      _defineProperty(this, "createSharePostLink", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const postIds = [...this.selectedPosts].map(post => post.id);
          try {
            const response = yield (0, _fetch.fetch)(`/api/v2/post_review_shares`, {
              method: _constants.HttpMethod.Post,
              body: {
                post_review_share: {
                  group_id: this.currentGroup.id,
                  post_ids: postIds
                }
              }
            });
            const {
              id,
              share_url,
              expires_time
            } = response.post_review_share;
            this.shareId = id;
            this.sharePostUrl = share_url;
            this.sharePostExpiresTime = expires_time * 1000;
          } catch (error) {
            this.alerts.alert(this.intl.t('alerts.calendar.share_posts_link.share_link_creation_failed.message'), {
              title: this.intl.t('alerts.calendar.share_posts_link.share_link_creation_failed.title')
            });
            this.errors.log(`Unable to create share post link for post_ids: ${postIds}`, error);
          }
        }
      }), null, "createSharePostLink", null));
      _classPrivateFieldInitSpec(this, _handleDrop, {
        writable: true,
        value: _ref => {
          let {
            date,
            draggedEl
          } = _ref;
          this.displayContextMenu = false;
          const {
            canDropOnCalendar,
            disableDrop,
            selectedAssets = []
          } = this.args;
          const multipleSelectedAssets = selectedAssets.length > 1;
          const scheduledTime = _classPrivateMethodGet(this, _getDroppedEventDateTime, _getDroppedEventDateTime2).call(this, date);
          const {
            mediaItemId
          } = draggedEl.dataset;
          const mediaTypeCount = {
            image: 0,
            video: 0
          };
          if (!canDropOnCalendar || disableDrop || this.isSelectMode) {
            return false;
          }
          if (multipleSelectedAssets) {
            this.segment.track('attempted-multi-photo-post');
          }
          if (!this.canCarousel && multipleSelectedAssets) {
            _classPrivateMethodGet(this, _displayCarouselWarning, _displayCarouselWarning2).call(this);
            return false;
          }
          if (!this.multipleProfilesSelected && this.socialProfile?.isTiktokUnverifiedAccount) {
            this.openTiktokRefreshModal(this.socialProfile);
            return false;
          }
          if (mediaItemId) {
            _classPrivateMethodGet(this, _trackBttpDrop, _trackBttpDrop2).call(this, date);
            if (mediaItemId === 'text') {
              _classPrivateMethodGet(this, _trackSchedulingPost, _trackSchedulingPost2).call(this, 'empty_post', mediaTypeCount);
              const singleOrMultiPost = this.multipleProfilesSelected ? _constants.ProfilePostType.Multi : _constants.ProfilePostType.Single;
              this.router.transitionTo(`cluster.schedule.calendar.post.${singleOrMultiPost}`, _constants.TEXT_POST_TYPE, {
                queryParams: {
                  scheduledTime
                }
              });
              return;
            }
            if (this.multipleProfilesSelected && selectedAssets.length <= 1) {
              _classPrivateMethodGet(this, _transitionToMultiPostCreation, _transitionToMultiPostCreation2).call(this, mediaItemId, scheduledTime);
            } else if (this.canCarousel && multipleSelectedAssets) {
              _classPrivateMethodGet(this, _createCarouselPost, _createCarouselPost2).call(this, scheduledTime, mediaItemId, selectedAssets);
            } else {
              _classPrivateMethodGet(this, _createPost, _createPost2).call(this, mediaItemId, scheduledTime);
            }
            const isTestImage = draggedEl.hasAttribute('data-media-item-is-test-image');
            const mediaType = isTestImage ? _constants.TEST_IMAGE_MEDIA_TYPE : this.store.peekRecord('media-item', mediaItemId)?.mediaType;
            if (multipleSelectedAssets) {
              mediaTypeCount.video = selectedAssets.filter(mediaItem => mediaItem.mediaType === 'video').length;
              mediaTypeCount.image = selectedAssets.filter(mediaItem => mediaItem.mediaType === 'image').length;
            } else if (isTestImage) {
              mediaTypeCount.image = 1;
            } else {
              const type = this.store.peekRecord('media-item', mediaItemId)?.mediaType;
              if (type === 'image' || type === 'video') {
                mediaTypeCount[type] = 1;
              }
            }
            _classPrivateMethodGet(this, _trackSchedulingPost, _trackSchedulingPost2).call(this, mediaType || '', mediaTypeCount);
            this.bttpTooltipRoot?.classList?.add?.('fc-bttp-tooltip__root--hidden');
          }
        }
      });
      _defineProperty(this, "_createNewTimeSlot", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (date) {
          if (!this.args.canCreateTimeSlots) {
            return;
          }
          const events = yield this.calendarEvents.getEvents.perform();
          const timeSlotEvents = events.any(event => event.eventType === TIME_SLOT);

          // Note: If no time slot events exist, open quick scheduling wizard - otherwise create a new time slot
          if (!timeSlotEvents) {
            this.args.showQuickScheduleWizard();
          } else if (this.fullCalendar?.view?.type === WEEK) {
            yield this.calendarTimeSlot.create((0, _moment.default)(date));
          }
          this.updateEvents();
        }
      }), null, "_createNewTimeSlot", null));
      _defineProperty(this, "_handleDateSet", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (start, end, calendar) {
          const targetDate = calendar.getDate();
          const formattedDate = (0, _moment.default)(targetDate).valueOf();
          yield this._updateEvents.perform({
            start,
            end
          });
          this.args.updateTargetDate(formattedDate);
          _classPrivateMethodGet(this, _updateEventDisplay, _updateEventDisplay2).call(this);
        }
      }), null, "_handleDateSet", null));
      _defineProperty(this, "_updateHeaderAndEvents", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.fullCalendar?.setOption('customButtons', this.customButtons);
          this.fullCalendar?.setOption('headerToolbar', this.calendarConfig.headerToolbar);
          yield this.updateEvents();
        }
      }), null, "_updateHeaderAndEvents", null));
      // Note: Update calendar events, events should already be in store from previous calls or createCalendar
      _defineProperty(this, "_updateEvents", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function () {
          var _this = this;
          let fetchInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.calendarEvents.defaultFetchInfo;
          return function* () {
            const {
              fullCalendar
            } = _this.calendarConfig;
            const events = yield _this.calendarEvents.getEvents.perform(_this.cachedData, fetchInfo);
            _this.calendarEvents.prefetch.perform(fetchInfo.start);
            _this.fullCalendar?.setOption('customButtons', _this.customButtons);
            _this.fullCalendar?.setOption('locale', _this.locale.primaryLocale);
            fullCalendar?.removeAllEvents();

            // Note: If on month view, display note events in non-standard format
            if (_this.isOnMonthView) {
              const postEvents = events.filter(_ref2 => {
                let {
                  eventType
                } = _ref2;
                return eventType === POST;
              });
              const noteEvents = events.filter(_ref3 => {
                let {
                  eventType
                } = _ref3;
                return eventType === NOTE;
              });
              yield fullCalendar?.addEventSource(postEvents);
              _classPrivateMethodGet(_this, _displayMonthViewNotes, _displayMonthViewNotes2).call(_this, noteEvents);
            } else if (!_this.isOnMonthView && !_this.permissions.showCalendarNotes) {
              _classPrivateMethodGet(_this, _addNonNoteEvents, _addNonNoteEvents2).call(_this, events);
            } else if (!_this.isOnMonthView) {
              yield fullCalendar?.addEventSource(events);
            }

            // on date/profile change await for post events to load before setting selected style
            setTimeout(() => {
              _this.postEvents.forEach(event => {
                if (_this.selectedPosts.has(event.extendedProps.post)) {
                  event.setExtendedProp('isSelected', true);
                }
              });
              _classPrivateMethodGet(_this, _updateSelectPostButtons, _updateSelectPostButtons2).call(_this);
            }, 0);
          }();
        }
      }), null, "_updateEvents", "keepLatest"));
      const showCalendarNotesCachedValue = this.cache.retrieve(this.calendarNotesCacheKey);
      if (typeof showCalendarNotesCachedValue === 'boolean') {
        this.showCalendarNotes = showCalendarNotesCachedValue;
      }
      this.postsPendingApproval.fetchCount.perform();
      this.bttpTooltipRoot = document.createElement('div');
      this.bttpTooltipRoot.classList.add('fc-bttp-tooltip__root');
      document.body.appendChild(this.bttpTooltipRoot);
    }
    willDestroy() {
      super.willDestroy();
      this.bttpTooltipRoot?.remove();
      this.bttpTooltipRoot = null;
      this.bttpDropdownOpen = false;
      this.bttpDropdownItems = [];
    }

    // Note: Read the tracked array directly rather than via a `@readOnly` alias, which can resolve to
    // `undefined` while FullCalendar re-runs `eventContent` during component teardown.
    get profiles() {
      return this.selectedSocialProfiles.profiles ?? [];
    }

    // Note: Calendar events are updated based on this object changing
    get cachedData() {
      return {
        ...(this.permissions.showBttp && {
          cacheBttpTimeSlots: this.profiles.filter(profile => this.bttp.toggledOn(profile)).flatMap(profile => this.bttp.report(profile)?.timeSlots ?? [])
        }),
        cachePosts: this.args.posts,
        cacheNotes: this.args.notes,
        cacheTimeSlots: !this.multipleProfilesSelected && this.socialProfile ? this.userTimeSlots : [],
        cacheBttpPromoState: this.socialProfile ? this.bttp.shouldShowBttpDiscovery(this.socialProfile) : false
      };
    }
    get bttpDropdownStyle() {
      return Object.keys(this.bttpDropdownStyleObj).reduce((styleStr, key) => {
        return styleStr + `${String(key)}: ${this.bttpDropdownStyleObj[key]}; `;
      }, '');
    }
    get selectPostText() {
      const allSelected = this.postEvents.every(event => event.extendedProps.isSelected);
      return allSelected ? this.intl.t('shared_phrases.deselect_all') : this.intl.t('shared_phrases.select_all');
    }
    get showFutureTrendsOnCalendar() {
      return this.auth.currentAccount?.rolloutFutureInsightsOnCalendar;
    }
    get customButtons() {
      // Note: Display preview and stories buttons if only an instagram profile is selected
      const displayAdditionalButtons = this.isInstagram && !this.multipleProfilesSelected;
      const buttons = {
        timezoneButton: {
          text: this.timeZoneIdentifier
        },
        calendarSettings: {
          icon: ' fc-icon-settings qa--calendar_settings_btn',
          click: () => this.args.viewCalendarSettings()
        },
        listButton: {
          text: this.intl.t('calendar.views.list'),
          click: () => this.router.transitionTo('cluster.schedule.list', {
            queryParams: this.router.currentRoute.queryParams
          })
        },
        sendPosts: {
          text: this.intl.t('calendar.views.send_posts_button'),
          click: () => this.toggleSelectMode()
        }
      };
      const additionalButtons = {
        previewButton: {
          text: this.intl.t('calendar.views.preview'),
          click: () => this.router.transitionTo('cluster.schedule.preview-grid')
        },
        storiesButton: {
          text: this.intl.t('calendar.views.stories'),
          click: () => this.router.transitionTo('cluster.schedule.stories')
        }
      };
      const selectPostsButtons = {
        selectAll: {
          text: this.selectPostText,
          click: () => this.selectAllVisiblePosts()
        },
        createLink: {
          text: this.intl.t('calendar.share_posts.create_link', {
            count: this.selectedPosts.size
          }),
          click: () => this.onClickCreateLink.perform()
        },
        cancel: {
          text: this.intl.t('shared_words.cancel'),
          click: () => this.toggleSelectMode()
        }
      };
      if (this.isSelectMode) {
        return selectPostsButtons;
      }
      return displayAdditionalButtons ? {
        ...buttons,
        ...additionalButtons
      } : buttons;
    }
    toggleSelectMode() {
      this.isSelectMode = !this.isSelectMode;
      this.isSelectMode ? this.segment.track(_segmentEvents.SegmentEventTypes.StartedSelectingPosts) : this.segment.track(_segmentEvents.SegmentEventTypes.CancelledSelectingPosts);
      this.selectedPosts.clear();
      this.calendarConfig.calendarType = this.calendarConfig.calendarType === SELECT ? DEFAULT : SELECT;
      _classPrivateMethodGet(this, _updateSelectPostButtons, _updateSelectPostButtons2).call(this);
      if (this.auth.currentAccount?.canExternalPostReview) {
        const hasSeenAlert = this.cache.retrieve(this.storiesAlertKey);
        if (!hasSeenAlert) {
          _classPrivateMethodGet(this, _showStoriesAlert, _showStoriesAlert2).call(this);
        }
      }
    }
    selectAllVisiblePosts() {
      if (this.postEvents.any(event => !event.extendedProps.isSelected)) {
        this.postEvents?.forEach(event => {
          event.setExtendedProp('isSelected', true);
          this.selectedPosts.add(event.extendedProps.post);
        });
      } else {
        this.postEvents?.forEach(event => {
          event.setExtendedProp('isSelected', false);
          this.selectedPosts.delete(event.extendedProps.post);
        });
      }
      _classPrivateMethodGet(this, _updateSelectPostButtons, _updateSelectPostButtons2).call(this);
    }
    get postEvents() {
      const events = this.fullCalendar?.getEvents().filter(event => event.extendedProps.post) ?? [];
      return events;
    }
    get fullCalendar() {
      return this.calendarConfig.fullCalendar;
    }
    get hasNoSocialProfile() {
      return (0, _utils.isEmpty)(this.auth.currentGroup.socialProfiles);
    }
    get isInstagram() {
      return this.socialProfile?.isInstagram;
    }
    get isOnMonthView() {
      return this.calendarView === MONTH;
    }
    get lastDay() {
      const {
        currentFirstDay
      } = this.auth;
      return currentFirstDay ? (currentFirstDay + 6) % 7 : undefined;
    }
    get monthViewNotes() {
      return Object.entries(this.notesByDate);
    }
    get permissions() {
      return {
        showBttp: this.profiles.some(profile => this.bttp.couldShow(profile.profileType)),
        showCalendarNotes: this.shouldShowCalendarNotes,
        showInstagramStories: this.canInstagramStories && !this.isOnMonthView && this.isInstagram && !this.multipleProfilesSelected && !this.isSelectMode,
        allowDraftPosts: true
      };
    }
    get hasSeenSelfDescribesAWhileAgo() {
      const hasSeenSelfDescribes = this.auth.discoveryListTasks?.find(_ref4 => {
        let {
          identifier
        } = _ref4;
        return identifier === _index.HAS_SEEN_SELF_DESCRIBES;
      });
      if (!hasSeenSelfDescribes) {
        return false;
      }
      const minutesSinceCompleted = (0, _moment.default)((0, _timeFormat.timestamp)() * 1000).diff(hasSeenSelfDescribes?.completedTime * 1000, 'minutes');
      return minutesSinceCompleted >= 10;
    }
    get shouldShowSocialConnectModal() {
      return this.showConnectSocialModal && this.hasNoSocialProfile && this.auth.currentUserModel.isAccountOwner && !this.onboarding.shouldShowSocialConnectOnboarding && this.hasSeenSelfDescribesAWhileAgo;
    }

    // Note: The time-slots passed in from the social-profile model are occasionally still in an unpersisted state
    // which causes issues when updating (due to non-existent ids)
    get userTimeSlots() {
      return this.socialProfile?.userTimeSlots?.filter(timeslot => timeslot.id) || [];
    }
    get shouldShowCalendarNotes() {
      return this.showCalendarNotes && this.canCalendarNotes;
    }
    get socialProfilesSelectedForScheduling() {
      return this.selectedSocialProfiles.profiles.map(profile => profile.accountType);
    }
    get hasMultipleBttpAccess() {
      return Boolean(this.auth.currentAccount.canMultipleBttp);
    }
    closeConnectSocialModal() {
      this.segment.track('dismissed-social-connect-modal');
      this.showConnectSocialModal = false;
    }
    copyPost() {
      const post = this.selectedPost;
      if (!post) return;
      this.hideContextMenu();
      this.router.transitionTo('cluster.schedule.calendar.post.edit', post.id, {
        queryParams: {
          copy: true
        }
      });
    }
    async discardPost() {
      const post = this.selectedPost;
      if (!post) return;
      this.hideContextMenu();
      this.router.transitionTo('cluster.schedule.calendar.post.edit', post.id);
      const didConfirm = await this.dialogManager.confirmation(this.intl.t('posts.edit.confirm_delete'), {
        confirmButton: this.intl.t('shared_words.discard')
      });
      if (didConfirm) {
        await this.schedulePost.destroyPost.perform(post);
      }
      this.router.transitionTo('cluster.schedule.calendar');
    }
    async createCalendar() {
      // Note: const self = this is required for createCalendar hooks
      // eslint-disable-next-line
      const self = this;
      self.calendarConfig.calendarType = DEFAULT;
      this.showConnectSocialModal = true;
      const calendarEl = document.getElementById('calendar');
      if (!calendarEl) {
        return this.errors.log('FullCalendar: No calendar element found', {}, _errors.ErrorSeverity.Critical);
      }
      const calendar = new _core.Calendar(calendarEl, {
        ...this.calendarConfig.commonConfig,
        customButtons: self.customButtons,
        dateClick: info => {
          _classPrivateMethodGet(this, _trackLastClick, _trackLastClick2).call(this, info);
          this.handleRightClick(info);
        },
        defaultTimedEventDuration: this.calendarEvents.defaultTimedEventDuration,
        droppable: true,
        // Note: Overridden on a per event basis
        editable: true,
        eventDurationEditable: true,
        eventResizableFromStart: false,
        eventStartEditable: true,
        eventTimeFormat: {
          hour12: true,
          hour: 'numeric',
          minute: '2-digit',
          meridiem: false
        },
        firstDay: this.auth.currentFirstDay ?? undefined,
        dayMaxEventRows: true,
        initialDate: this.calendarConfig.targetDateObject(this.args.targetDate),
        initialView: this.calendarConfig.isValidCalendarView(this.args.calendarView) ? this.args.calendarView : this.calendarConfig.calendarView,
        locales: [_de.default, _es.default, _fr.default],
        locale: this.locale.primaryLocale,
        views: {
          [WEEK]: {
            dayHeaderFormat: {
              weekday: 'short',
              day: 'numeric'
            }
          },
          [MONTH]: {
            // Note: Removed dayHeaderFormat as per this open issue: https://github.com/fullcalendar/fullcalendar/issues/5854
            dayMaxEvents: 6
          }
        },
        // Note: Add hover class to note event element
        eventMouseEnter(_ref5) {
          let {
            event,
            el
          } = _ref5;
          if (event.extendedProps.eventType === NOTE) {
            const noteEventStartDay = event.extendedProps.startDay;
            el.querySelector('.fc-note')?.classList.add('fc-event_hover');
            if (noteEventStartDay === self.lastDay) {
              el.querySelector('.fc-note')?.classList.add('fc-event_hover--last');
            }
          }
        },
        // Note: Remove hover class from note event element
        eventMouseLeave(_ref6) {
          let {
            event,
            el
          } = _ref6;
          if (event.extendedProps.eventType === NOTE) {
            el.querySelector('.fc-note')?.classList.remove('fc-event_hover', 'fc-event_hover--last');
          }
        },
        viewDidMount: _ref7 => {
          let {
            view
          } = _ref7;
          self.calendarConfig.set('calendarView', view.type);
          const scrollContainer = document.querySelector('.fc-scrollgrid-section-body');
          if (!scrollContainer) {
            return this.errors.log('Stories/FullCalendar: No scroll container element found', {}, _errors.ErrorSeverity.Critical);
          }
          new _perfectScrollbar.default(scrollContainer);
          // style send posts button
          const sendPostsButton = document.querySelector('.fc-sendPosts-button');
          sendPostsButton?.classList.add('cSP--sendPostsButton');
          _classPrivateMethodGet(self, _updateEventDisplay, _updateEventDisplay2).call(self);
        },
        // Note: Using fullcalendar's 'eventContent` content injection API to ensure styling isn't lost
        // during the library's internally triggered event changes
        eventContent: _ref8 => {
          let {
            event
          } = _ref8;
          const {
            extendedProps,
            start
          } = event;
          const {
            eventType,
            noteColor,
            noteSummary
          } = extendedProps;
          if (eventType === POST) {
            const eventContentWrapper = _classPrivateMethodGet(self, _generatePostContent, _generatePostContent2).call(self, event);
            return {
              domNodes: [eventContentWrapper]
            };
          }
          if (eventType === NOTE) {
            const noteContentContainer = document.createElement('div');
            noteContentContainer.classList.add('fc-note');
            const noteBackgroundColor = (0, _hexToRgb.default)(noteColor, 0.3);
            if (noteBackgroundColor) {
              noteContentContainer.style.backgroundColor = noteBackgroundColor;
            }
            noteContentContainer.innerHTML = _markupBuilders.default.note(self.intl, noteSummary);
            return {
              domNodes: [noteContentContainer]
            };
          }
          if (eventType === BTTP) {
            /** Don't show bttp if:
             * More than 1 selected profile AND
             * Has no access to multiple bttp AND
             * Trial has expired
             *
             * Note - we do show BTTP values for a single selected profile
             */
            const isMultipleAndNeedsUpgrade = self.selectedSocialProfiles.count > 1 && !self.hasMultipleBttpAccess;
            if (isMultipleAndNeedsUpgrade && (!self.bttp.hasAcceptedMultiBttpTrial || self.bttp.multipleBttpTrialExpired)) return;
            const bttpGridContainer = document.createElement('div');
            bttpGridContainer.classList.add('fc-bttp-grid-container');
            const {
              bttps,
              groupStartMins,
              groupEndMins
            } = extendedProps;
            const startWithTimeZone = start ? _moment.default.tz(start, self.timeZoneIdentifier) : null;
            bttpGridContainer.setAttribute('data-test-id', `bttp-grid-container-${startWithTimeZone?.format('hh:mma')}`);
            if (!(0, _utils.isEmpty)(bttps)) {
              const groupDuration = groupEndMins - groupStartMins;
              const MAX_VISIBLE = 5;
              const isOverLimit = bttps.length > MAX_VISIBLE;
              const visibleBttps = bttps.slice(0, MAX_VISIBLE);
              visibleBttps.forEach(bttp => {
                const profileBttp = document.createElement('div');
                profileBttp.classList.add('fc-bttp', `fc-bgevent__${bttp.profileColorClass}`);
                profileBttp.setAttribute('data-test-id', `bttp-profile-${bttp.socialProfileId}`);
                profileBttp.addEventListener('click', e => {
                  e.stopPropagation();
                  if (start) {
                    self.scheduleFromBttp(bttp, start);
                  }
                }, true);
                const topPercent = (bttp.startMins - groupStartMins) / groupDuration * 100;
                profileBttp.style.top = `${topPercent}%`;
                profileBttp.innerHTML = _markupBuilders.default.bttpSvg();
                profileBttp.dataset.bttpIndex = String(bttps.indexOf(bttp));
                bttpGridContainer.appendChild(profileBttp);
              });
              if (isOverLimit) {
                const overflowButton = document.createElement('div');
                overflowButton.role = 'button';
                overflowButton.setAttribute('data-test-id', `bttp-overflow-button-${startWithTimeZone?.format('hh:mma')}`);
                overflowButton.classList.add('fc-bttp', 'fc-bttp-dropdown-trigger');
                overflowButton.innerHTML = _markupBuilders.default.bttpOverflowIndicator();
                overflowButton.addEventListener('click', e => {
                  e.stopPropagation();
                  self.bttpDropdownItems = bttps.map(bttp => ({
                    ...bttp,
                    date: start
                  }));
                  const rect = overflowButton.getBoundingClientRect();
                  const margin = 8;
                  const gap = 4;
                  const dropdownWidth = 300;
                  const spaceBelow = window.innerHeight - rect.bottom - margin;
                  const spaceAbove = rect.top - 70 - margin; // theres a 70px header that we need to account for when positioning above
                  const spaceRight = window.innerWidth - rect.left - margin;
                  const spaceLeft = rect.right - margin;
                  const positionAbove = spaceBelow < spaceAbove;
                  const positionLeft = spaceRight < dropdownWidth && spaceLeft >= dropdownWidth;
                  const verticalStyle = positionAbove ? {
                    bottom: `${window.innerHeight - rect.top + gap}px`,
                    'max-height': `${spaceAbove}px`
                  } : {
                    top: `${rect.bottom + gap}px`,
                    'max-height': `${Math.max(spaceBelow, 100)}px`
                  };
                  const horizontalStyle = positionLeft ? {
                    right: `${window.innerWidth - rect.right}px`
                  } : {
                    left: `${rect.left}px`
                  };
                  self.bttpDropdownStyleObj = {
                    ...verticalStyle,
                    ...horizontalStyle
                  };
                  self.bttpDropdownOpen = true;
                  overflowButton.classList.add('is--active');
                }, true);
                bttpGridContainer.appendChild(overflowButton);
              }

              // use a listener on the container to avoid attaching multiple listeners for each individual bttp element, which can cause performance issues
              bttpGridContainer.addEventListener('mouseenter', e => {
                const target = e.target.closest('[data-bttp-index]');
                if (!target || !self.bttpTooltipRoot) return;
                const bttp = bttps[Number(target.dataset.bttpIndex)];
                if (!bttp) return;
                self.bttpTooltipRoot.innerHTML = _markupBuilders.default.bttpTooltip(self.intl, bttp);

                // Move off-screen and unhide so the browser can compute dimensions
                self.bttpTooltipRoot.style.top = '-9999px';
                self.bttpTooltipRoot.style.left = '-9999px';
                self.bttpTooltipRoot.classList.remove('fc-bttp-tooltip__root--hidden');
                const rect = target.getBoundingClientRect();
                const tooltipWidth = self.bttpTooltipRoot.offsetWidth;
                const tooltipHeight = self.bttpTooltipRoot.offsetHeight + 8; // +4px to create small gap;
                const margin = 2;
                const centerLeft = rect.left + rect.width / 2 - tooltipWidth / 2;
                const clampedLeft = Math.min(Math.max(centerLeft, margin), window.innerWidth - tooltipWidth - margin);
                const caretHalfWidth = parseFloat(getComputedStyle(document.documentElement).fontSize);
                const caretLeft = Math.min(Math.max(rect.left + rect.width / 2 - clampedLeft, caretHalfWidth), tooltipWidth - caretHalfWidth);
                self.bttpTooltipRoot.style.setProperty('--bttp-caret-left', `${caretLeft}px`);
                self.bttpTooltipRoot.style.top = `${rect.top - tooltipHeight}px`;
                self.bttpTooltipRoot.style.left = `${clampedLeft}px`;
              }, true);
              bttpGridContainer.addEventListener('mouseleave', e => {
                const target = e.target.closest('[data-bttp-index]');
                if (target) self.bttpTooltipRoot?.classList.add('fc-bttp-tooltip__root--hidden');
              }, true);
            }
            return {
              domNodes: [bttpGridContainer]
            };
          }
          if (eventType === NOTES_PROMO) {
            const notesPromoContainer = document.createElement('div');
            const notesPromoMarkup = _markupBuilders.default.notesPromo(self.intl);
            notesPromoContainer.classList.add('fc-discover-promo', 'fc-notes-promo');
            self.calendarMarkup.insertMarkup(_markup.MarkupInsertionType.Prepend, notesPromoContainer, notesPromoMarkup);
            return {
              domNodes: [notesPromoContainer]
            };
          }
          if (eventType === BTTP_PROMO) {
            // Note: Do not display promo if timeslots already exist
            if (self.profiles.some(profile => self.bttp.report(profile)?.timeSlots?.length)) {
              return;
            }
            const bttpPromoContentContainer = document.createElement('div');
            const bttpPromoMarkup = _markupBuilders.default.bttpPromo(self.intl);
            bttpPromoContentContainer.classList.add('fc-discover-promo', 'fc-bttp-promo');
            self.calendarMarkup.insertMarkup(_markup.MarkupInsertionType.Prepend, bttpPromoContentContainer, bttpPromoMarkup);
            return {
              domNodes: [bttpPromoContentContainer]
            };
          }
          if (eventType === TIME_SLOT) {
            const eventContentWrapper = _classPrivateMethodGet(self, _generateTimeSlotContent, _generateTimeSlotContent2).call(self, start);
            return {
              domNodes: [eventContentWrapper]
            };
          }
        },
        eventDidMount: _ref9 => {
          let {
            el,
            event
          } = _ref9;
          const {
            extendedProps: {
              eventType,
              post
            }
          } = event;
          if (this.isSelectMode) {
            if (eventType === POST && !post.isInstagramStory) {
              event.setProp('editable', false);
            } else {
              el.style.display = 'none'; // Hide non-POST events
            }
          }
          if (eventType === POST) {
            self.schedulePost.confirmThumbnailExists(post);
            el.addEventListener('contextmenu', e => {
              e.preventDefault();
              e.stopPropagation(); // Prevent bubbling to calendar's contextmenu handler
              el.blur();
              _classPrivateMethodGet(self, _handlePostRightClick, _handlePostRightClick2).call(self, post, e, el.parentElement);
            });
          }
          _classPrivateMethodGet(self, _addParentClasses, _addParentClasses2).call(self, el, eventType);
        },
        eventClick(info) {
          const {
            jsEvent,
            event
          } = info;
          const {
            extendedProps,
            id
          } = event || {};
          if (!extendedProps) {
            return;
          }
          const {
            post
          } = extendedProps;
          const target = jsEvent.target;
          const destroyEventClass = 'e--fc-slot-destroy';
          _classPrivateMethodGet(self, _trackLastClick, _trackLastClick2).call(self, info);
          switch (extendedProps.eventType) {
            case BTTP_PROMO:
              self.showBttpPromoModal = true;
              self.segment.track('enable-bttp-intent', {
                social_profile_handle: self.socialProfile.nickname ?? null,
                active_trial: !!self.subscriptions.hasActiveTrial
              });
              break;
            case POST:
              if (self.isSelectMode) {
                if (self.selectedPosts.has(extendedProps.post)) {
                  event?.setExtendedProp('isSelected', false);
                  self.selectedPosts.delete(extendedProps.post);
                } else {
                  event?.setExtendedProp('isSelected', true);
                  self.selectedPosts.add(extendedProps.post);
                }
                _classPrivateMethodGet(self, _updateSelectPostButtons, _updateSelectPostButtons2).call(self);
                return;
              }
              self.trackClickedPost(post);
              self.args.openEvent(extendedProps.post.id);
              break;
            case NOTES_PROMO:
              self.segment.track('discovered-note');
              self.calendarEvents.seenNotesPromo();
              self.showNotesPromoModal = true;
              break;
            case NOTE:
              self.calendarNote.transitionToEdit(extendedProps.note.id);
              break;
            case TIME_SLOT:
              if (id && target?.classList.contains(destroyEventClass)) {
                _classPrivateMethodGet(self, _destroyTimeSlot, _destroyTimeSlot2).call(self, id);
              }
              break;
          }
        },
        async eventDrop(_ref10) {
          let {
            event,
            revert
          } = _ref10;
          const {
            extendedProps: {
              eventType,
              post
            },
            start
          } = event;
          if (!start) {
            return self.errors.log('FullCalendar: No start time provided to eventDrop');
          }
          const startTime = _classPrivateMethodGet(self, _getDateWithTimeZone, _getDateWithTimeZone2).call(self, start).unix();
          switch (eventType) {
            case POST:
              if (post.isDraft && !self.permissions.allowDraftPosts) {
                self.alertDraftPostUpgrade();
                revert();
              } else {
                await self.schedulePost.updateTime.perform(event, startTime);
              }
              break;
            case TIME_SLOT:
              _classPrivateMethodGet(self, _updateTimeSlotTime, _updateTimeSlotTime2).call(self, event);
              break;
            case NOTE:
              self.displayContextMenu = false;
              _classPrivateMethodGet(self, _updateNoteTime, _updateNoteTime2).call(self, event);
              break;
          }
        },
        drop(_ref11) {
          let {
            date,
            draggedEl
          } = _ref11;
          // Note: This debounce can likely be removed once drag and drop has been updated (internal/replace-jquery-drag-and-drop)
          (0, _runloop.debounce)(self, _classPrivateFieldGet(self, _handleDrop), {
            date,
            draggedEl
          }, 500);
        }
      });
      self.calendarConfig.set('fullCalendar', calendar);
      calendar.render();
      self.calendarMarkup.updateCalendarSettingsButton();
      _classPrivateMethodGet(self, _updateBttp, _updateBttp2).call(self);
      self.calendarConfig.handleWithProgressBar.perform(() => this._updateEvents.perform());

      // Note: Remove and add event sources based on new dates, update 'targetDate'
      calendar.on('datesSet', _ref12 => {
        let {
          start,
          end
        } = _ref12;
        this.calendarConfig.handleWithProgressBar.perform(() => this._handleDateSet.perform(start, end, calendar));
      });
    }
    trackClickedPost(post) {
      const calendarView = this.fullCalendar?.view?.type === WEEK ? 'weekly' : 'monthly';
      const hoursFromNow = (0, _time.hoursBetweenUnixTimestamps)((0, _timeFormat.timestamp)(), post.displayTime);
      let postType;
      if (post.gramType === 'text' || post.gramType === 'video') {
        postType = post.gramType;
      } else {
        postType = post.isCarouselPost ? 'image carousel' : 'image single';
      }
      let publishedState;
      if (post.isDraft) {
        publishedState = 'draft';
      } else if (post.scheduledInFuture) {
        publishedState = 'scheduled';
      } else if (post.isPosted) {
        publishedState = 'published';
      }
      this.segment.track('clicked-post-on-calendar', {
        published_state: publishedState ?? '',
        post_status: post.state ?? '',
        calendar_view: calendarView,
        hours_from_now: hoursFromNow,
        post_id: post.id,
        post_type: postType || ''
      });
    }
    alertAndDisplayNotes() {
      if (!this.showCalendarNotes) {
        this.alerts.success(this.intl.t('alerts.calendar_notes.turning_on.message'), {
          title: this.intl.t('alerts.calendar_notes.turning_on.title'),
          timeout: 5000
        });
      }
      _classPrivateMethodGet(this, _turnOnCalendarNotes, _turnOnCalendarNotes2).call(this);
    }
    createNewCalendarNote(source) {
      this.segment.track('clicked-create-note', {
        button_location: 'calendar page'
      });
      if (this.canCalendarNotes) {
        const noteDate = source === NOTES_PROMO ? this.calendarEvents.selectedNoteDateWithNotesPromo : this.selectedNoteDate;
        this.alertAndDisplayNotes();
        this.calendarNote.create(noteDate);
        this.hideContextMenu();
      } else {
        this.shouldShowNotesTrialStartModal = true;
      }
    }
    closeTiktokRefreshModal() {
      this.showTiktokRefreshModal = false;
    }
    editCalendarNote(id, closeAction) {
      this.calendarNote.transitionToEdit(id);
      closeAction();
    }

    // Note: If double click target meets criteria, create new user time slot
    handleDoubleClick(_ref13) {
      let {
        srcElement
      } = _ref13;
      if (!this.lastClickInfo || this.hasNoSocialProfile || this.isSelectMode) {
        return;
      }
      const {
        date,
        view
      } = this.lastClickInfo;
      const target = this.lastClickInfo.target;
      const isValidTarget = _classPrivateMethodGet(this, _isValidTimeSlotTarget, _isValidTimeSlotTarget2).call(this, target?.classList) && _classPrivateMethodGet(this, _isValidTimeSlotTarget, _isValidTimeSlotTarget2).call(this, srcElement.classList);
      if (view === WEEK && isValidTarget) {
        this._createNewTimeSlot.perform(date);
      }
    }
    hideContextMenu() {
      this.displayContextMenu = false;
    }
    openTiktokRefreshModal(tiktokProfile) {
      this.selectedTiktokProfile = tiktokProfile;
      this.showTiktokRefreshModal = true;
    }
    toggleCalendarNotes() {
      const {
        ON,
        OFF
      } = CALENDAR_NOTE_STATES;
      const newState = this.showCalendarNotes ? ON : OFF;
      this.showCalendarNotes = !this.showCalendarNotes;
      this.cache.add(this.calendarNotesCacheKey, this.showCalendarNotes, {
        expiry: this.cache.maxExpiryDate(),
        persist: true
      });
      this.segment.track('toggled-show-calendar-notes', {
        new_state: newState
      });
    }
    updateCalendar() {
      this.calendarConfig.handleWithProgressBar.perform(() => {
        _classPrivateMethodGet(this, _updateBttp, _updateBttp2).call(this);
        this._updateHeaderAndEvents.perform();
      });
    }
    updateEvents() {
      this._updateEvents.perform();
    }
    closeNotesTrialStartModal() {
      this.shouldShowNotesTrialStartModal = false;
      this.segment.track('dismissed-upgrade-intent', {
        button_location: 'calendar page note discoverability'
      });
    }
    closeBttpDropdown() {
      this.bttpDropdownOpen = false;
      this.bttpDropdownItems = [];
      document.querySelector('.fc-bttp.fc-bttp-dropdown-trigger.is--active')?.classList.remove('is--active');
    }
    scheduleFromBttp(bttp, start) {
      if (!start) return;
      if (this.bttpDropdownOpen) this.closeBttpDropdown();
      this.bttpTooltipRoot?.classList.add('fc-bttp-tooltip__root--hidden');
      const target = _classPrivateMethodGet(this, _getDateWithTimeZone, _getDateWithTimeZone2).call(this, start).startOf('day').add(bttp.startMins, 'minutes');
      this.router.transitionTo(`cluster.schedule.calendar.post.${_constants.ProfilePostType.Single}`, _constants.TEXT_POST_TYPE, {
        queryParams: {
          backTo: 'cluster.schedule.calendar',
          scheduledTime: target.unix(),
          socialProfileId: bttp.socialProfileId
        }
      });
    }

    /**
     * Show an alert for upgrading plan to one that supports the creation and
     * editing of draft posts.
     */
    alertDraftPostUpgrade() {
      this.alerts.upgrade(this.intl.t('drafts.alerts.upgrade.message'), {
        title: this.intl.t('drafts.alerts.upgrade.title'),
        type: 'info',
        feature: 'draftPosts',
        location: 'draft posts schedule flash message',
        upgradeText: this.intl.t('shared_phrases.upgrade_plan'),
        upgradeQaClassName: 'qa--draftPostsUpsell_upgradePlan_Btn'
      });
    }
    handleRightClick(info) {
      const isRightClick = info.jsEvent.button === 2;
      const isCtrlClick = info.jsEvent.button === 0 && info.jsEvent.ctrlKey === true;
      if (!(isRightClick || isCtrlClick)) return;
      info.jsEvent.preventDefault();
      this.menuLeft = info.jsEvent.pageX;
      this.menuTop = info.jsEvent.pageY;

      // Always set the date for note creation regardless of what's clicked
      this.selectedNoteDate = _moment.default.tz(info.dateStr, this.timeZoneIdentifier);

      // Check if the right-click is on a post event
      const target = info.jsEvent.target;
      const postEventInfo = _classPrivateMethodGet(this, _findPostEvent, _findPostEvent2).call(this, target);
      // Reset previous highlight if any
      _classPrivateMethodGet(this, _resetPostHighlight, _resetPostHighlight2).call(this);
      if (postEventInfo) {
        // If we right-clicked on a post, set it as the selected post and add highlight
        this.selectedPost = postEventInfo.event.extendedProps.post;
        this.selectedPostElement = postEventInfo.element;
        _classPrivateMethodGet(this, _addPostHighlight, _addPostHighlight2).call(this, this.selectedPostElement);
      } else {
        // If we right-clicked elsewhere, just set selectedPost to null
        this.selectedPost = null;
        this.selectedPostElement = null;
      }
      this.displayContextMenu = true;
    }
    handleBttpDropdownKeydown(event) {
      if (this.bttpDropdownOpen && event.key === 'Escape') {
        this.closeBttpDropdown();
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "calendarEvents", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "calendarMarkup", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "calendarNote", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "calendarTimeSlot", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "schedulePost", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "postsPendingApproval", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "displayContextMenu", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "menuLeft", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "menuTop", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "selectedNoteDate", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "notesByDate", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "selectedTiktokProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "showBttpPromoModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "showNotesPromoModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "showCalendarNotes", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "showConnectSocialModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "showTiktokRefreshModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "shouldShowNotesTrialStartModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "isSelectMode", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "selectedPosts", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedSet();
    }
  }), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "shareId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "sharePostUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "sharePostExpiresTime", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "showSharePostsModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "selectedPost", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "selectedPostElement", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "bttpTooltipRoot", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "bttpDropdownOpen", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "bttpDropdownItems", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "bttpDropdownStyleObj", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {
        top: '0px',
        left: '0px'
      };
    }
  }), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "account", [_dec9], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "canCarousel", [_dec10], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "canInstagramStories", [_dec11], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "calendarView", [_dec12], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "canCalendarNotes", [_dec13], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "socialProfile", [_dec14], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "multipleProfilesSelected", [_dec15], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "currentGroup", [_dec16], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "timeZoneIdentifier", [_dec17], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeConnectSocialModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeConnectSocialModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "copyPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "discardPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "discardPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertAndDisplayNotes", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "alertAndDisplayNotes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createNewCalendarNote", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createNewCalendarNote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTiktokRefreshModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTiktokRefreshModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editCalendarNote", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editCalendarNote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDoubleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDoubleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideContextMenu", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideContextMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openTiktokRefreshModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openTiktokRefreshModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCalendarNotes", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCalendarNotes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateEvents", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeNotesTrialStartModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeNotesTrialStartModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeBttpDropdown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeBttpDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scheduleFromBttp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "scheduleFromBttp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRightClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRightClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleBttpDropdownKeydown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBttpDropdownKeydown"), _class.prototype)), _class));
  function _findPostEvent2(element) {
    let currentElement = element;
    while (currentElement && !currentElement.classList.contains('fc-post-harness')) {
      currentElement = currentElement.parentElement;
    }
    if (!currentElement) {
      return null;
    }
    const events = this.fullCalendar?.getEvents() || [];
    const matchingEvent = events.find(
    // @ts-expect-error disable-next-line
    event => event.extendedProps.eventType === POST && event.el && event.el.parentElement === currentElement);
    return matchingEvent ? {
      event: matchingEvent,
      element: currentElement
    } : null;
  }
  function _addPostHighlight2(element) {
    if (element) {
      element.classList.add('cCA--post--highlighted');
    }
  }
  function _resetPostHighlight2() {
    if (this.selectedPostElement) {
      this.selectedPostElement.classList.remove('cCA--post--highlighted');
    }
  }
  function _handlePostRightClick2(post, event, element) {
    // Prevent the default browser context menu
    event.preventDefault();

    // Set the menu position
    this.menuLeft = event.pageX;
    this.menuTop = event.pageY;

    // Reset any previous highlight
    _classPrivateMethodGet(this, _resetPostHighlight, _resetPostHighlight2).call(this);

    // Set the selected post and highlight it
    this.selectedPost = post;
    this.selectedPostElement = element;
    _classPrivateMethodGet(this, _addPostHighlight, _addPostHighlight2).call(this, element);

    // Also set the selectedNoteDate based on the post's date
    if (post.displayTime) {
      this.selectedNoteDate = _moment.default.unix(post.displayTime);
    } else {
      // Default to current date if post has no display time
      this.selectedNoteDate = (0, _moment.default)();
    }

    // Show the context menu
    this.displayContextMenu = true;
  }
  async function _addNonNoteEvents2() {
    let events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const nonNoteEvents = events.filter(_ref14 => {
      let {
        eventType
      } = _ref14;
      return eventType !== NOTE;
    });
    await this.calendarConfig?.fullCalendar?.addEventSource(nonNoteEvents);
  }
  function _addParentClasses2(el, eventType) {
    if (!el.parentElement) {
      return;
    }
    switch (eventType) {
      case POST:
        el.parentElement.classList.add('fc-post-harness');
        break;
      case NOTE:
        el.parentElement.classList.add('fc-note-harness');
        break;
      case BTTP:
        el.parentElement.classList.add('fc-bttp-harness');
        break;
      case BTTP_PROMO:
        el.parentElement.classList.add('fc-bttp-promo-harness');
        break;
      case TIME_SLOT:
        el.parentElement.classList.add('fc-time-slot-harness');
        break;
    }
  }
  function _createPost2(mediaItemId, scheduledTime) {
    const {
      isPinterest,
      isBusiness
    } = this.socialProfile || {};
    const mediaItem = this.store.peekRecord('media-item', mediaItemId);
    if (mediaItem?.isVideo && isPinterest && !isBusiness) {
      this.args.enablePinterestBusiness();
    } else {
      _classPrivateMethodGet(this, _transitionToPostCreation, _transitionToPostCreation2).call(this, mediaItemId, scheduledTime);
    }
  }
  function _createCarouselPost2(scheduledTime, mediaItemId, selectedAssets) {
    const {
      isInstagram,
      isThreads,
      isTiktok
    } = this.socialProfile || {};
    const containsImage = selectedAssets.some(asset => asset.isImage);
    const containsVideo = selectedAssets.some(asset => asset.isVideo);
    const validCarouselProfile = isInstagram || containsImage || isTiktok && !containsVideo || isThreads;
    if (this.multipleProfilesSelected) {
      _classPrivateMethodGet(this, _transitionToMultiPostCreation, _transitionToMultiPostCreation2).call(this, mediaItemId, scheduledTime);
    } else if (validCarouselProfile) {
      _classPrivateMethodGet(this, _transitionToPostCreation, _transitionToPostCreation2).call(this, mediaItemId, scheduledTime);
    } else {
      const message = (0, _translationPaths.buildRestrictionsInfoString)(this.socialProfile, 'alerts.posts.carousel');
      this.alerts.warning(this.intl.t(message));
    }
  }
  function _destroyTimeSlot2(id) {
    if ((0, _utils.isNone)(id)) {
      this.errors.log(new Error('Trying to delete timeslot - record has no id'), {
        socialProfileId: this.socialProfile.id
      });
    }
    if (!this.multipleProfilesSelected) {
      this.calendarTimeSlot.delete(id);
    }
  }
  function _displayCarouselWarning2() {
    const upgradeMessage = this.account.canTrialPlan ? this.intl.t('alerts.calendar.cannot_schedule_carousel_free.message_trial') : this.intl.t('alerts.calendar.cannot_schedule_carousel_free.message');
    this.alerts.upgrade(upgradeMessage, {
      title: this.intl.t('alerts.calendar.cannot_schedule_carousel_free.title'),
      type: 'info',
      feature: 'multiPhoto',
      location: 'multi photo schedule flash message',
      upgradeText: this.intl.t('shared_phrases.upgrade_plan'),
      upgradeQaClassName: 'qa--carouselUpsell_upgradePlan_Btn'
    });
  }
  async function _displayMonthViewNotes2(notes) {
    const monthViewElementClass = 'fc-note-month';

    // Note: Clear existing note markup
    this.notesByDate = {};
    document.querySelectorAll(`.${monthViewElementClass}`)?.forEach(node => node.remove());

    // Note: Group notes by date
    notes.forEach(note => {
      if (!note || !note.start) {
        return;
      }
      const formattedEventDate = (0, _moment.default)(note.start).format(this.dateFormat);
      const dateContainer = document.querySelector(`[data-date="${formattedEventDate}"]`);

      // Note: If date isn't currently visible on calendar, don't attempt to render note display
      if (!dateContainer) {
        return;
      }
      if (!this.notesByDate[formattedEventDate]) {
        this.notesByDate[formattedEventDate] = [note];
      }
      if (!this.notesByDate[formattedEventDate].find(noteByDate => noteByDate.id === note.id)) {
        this.notesByDate[formattedEventDate] = [...this.notesByDate[formattedEventDate], note];
      }
    });

    // Note: Add markup for notes on each given date
    const noteDates = Object.keys(this.notesByDate);
    noteDates.forEach(date => {
      const formattedDate = (0, _moment.default)(date).format(this.dateFormat);
      const numberOfNotes = this.notesByDate[date].length;
      const noteHintMarkup = _markupBuilders.default.noteHint(formattedDate, numberOfNotes);
      const child = document.querySelector(`[data-date="${formattedDate}"]`)?.firstChild;
      const noteHintElement = this.calendarMarkup.insertMarkup(_markup.MarkupInsertionType.Prepend, child, noteHintMarkup);
      noteHintElement.setAttribute('class', monthViewElementClass);
    });
  }
  function _generatePostContent2(event) {
    const eventContentWrapper = document.createElement('div');
    const postTimeContainer = document.createElement('div');
    const postContentContainer = document.createElement('div');
    const postIconContainer = document.createElement('div');
    const postElements = {
      postTimeContainer,
      postContentContainer,
      postIconContainer,
      eventContentWrapper
    };
    this.calendarMarkup.updateCommonPostMarkup(postElements, event, this.isSelectMode);
    eventContentWrapper.appendChild(postTimeContainer);
    eventContentWrapper.appendChild(postContentContainer);
    eventContentWrapper.appendChild(postIconContainer);
    return eventContentWrapper;
  }
  function _generateTimeSlotContent2(start) {
    const eventContentWrapper = document.createElement('div');
    const eventTime = _moment.default.tz(start, this.timeZoneIdentifier).format('h:mm');
    const timeSlotTimeContainer = document.createElement('div');
    timeSlotTimeContainer.innerHTML = `<div class='fc-event-time'>${eventTime}</div>`;
    const timeSlotContentContainer = document.createElement('div');
    eventContentWrapper.classList.add('fc-slot');
    const timeSlotMarkup = _markupBuilders.default.timeSlot();
    this.calendarMarkup.insertMarkup(_markup.MarkupInsertionType.Append, timeSlotContentContainer, timeSlotMarkup);
    eventContentWrapper.appendChild(timeSlotTimeContainer);
    eventContentWrapper.appendChild(timeSlotContentContainer);
    return eventContentWrapper;
  }
  function _getDroppedEventDateTime2(date) {
    const now = (0, _moment.default)();
    const dateForView = this.isOnMonthView ? new Date(_moment.default.tz(date, this.timeZoneIdentifier).hour(12).format()) : date;
    const isPastDate = now.isAfter(dateForView);
    const dateTimeInMilliseconds = isPastDate ? new Date(now.format()).getTime() : dateForView.getTime();
    return dateTimeInMilliseconds / 1000;
  }
  function _getDateWithTimeZone2(date) {
    return _moment.default.tz(date.toISOString(), this.timeZoneIdentifier);
  }
  function _trackBttpDrop2(date) {
    const events = this.fullCalendar?.getEvents() ?? [];
    const matchingEvent = events.find(event => {
      if (event.extendedProps.eventType !== BTTP) return false;
      if (!event.start || !event.end) return false;
      return date >= event.start && date < event.end;
    });
    const bttps = matchingEvent?.extendedProps.bttps ?? [];
    if (!bttps.length) return;
    const trackedTypes = new Set();
    bttps.forEach(bttp => {
      const profileType = bttp.socialProfile?.profileType;
      if (!profileType || trackedTypes.has(profileType)) return;
      trackedTypes.add(profileType);
      const eventName = `scheduled-${profileType}-bttp-calendar`;
      this.segment.track(eventName);
    });
  }
  function _isValidTimeSlotTarget2(classList) {
    return classList.contains('fc-bg-event') || classList.contains('fc-timegrid-event-harness') || classList.contains('fc-timegrid-now-indicator-container');
  }
  function _setEventsDisplay2(events, displayType) {
    events.forEach(event => {
      if (event.extendedProps.eventType !== POST) {
        event.setProp('display', displayType);
      }
    });
  }
  function _trackLastClick2(_ref15) {
    let {
      date,
      jsEvent,
      view
    } = _ref15;
    if (!date || !jsEvent || !view) {
      return;
    }
    this.lastClickInfo = {
      date,
      target: jsEvent.target,
      view: view.type
    };
  }
  function _transitionToMultiPostCreation2(mediaItemId, scheduledTime) {
    performance.mark('BeginPostV2');
    this.router.transitionTo('cluster.schedule.calendar.post.multi', mediaItemId, {
      queryParams: {
        scheduledTime,
        calendarDrop: true
      }
    });
  }
  function _transitionToPostCreation2(mediaItemId, scheduledTime) {
    performance.mark('BeginPostV2');
    this.router.transitionTo('cluster.schedule.calendar.post.new', mediaItemId, {
      queryParams: {
        scheduledTime,
        calendarDrop: true
      }
    });
  }
  function _turnOnCalendarNotes2() {
    this.showCalendarNotes = true;
    this.cache.add(this.calendarNotesCacheKey, this.showCalendarNotes, {
      expiry: this.cache.maxExpiryDate(),
      persist: true
    });
  }
  function _updateEventDisplay2() {
    const {
      fullCalendar
    } = this.calendarConfig;
    const events = fullCalendar?.getEvents();
    if (events && this.isOnMonthView) {
      _classPrivateMethodGet(this, _setEventsDisplay, _setEventsDisplay2).call(this, events, 'none');
    }
  }
  function _updateNoteTime2(event) {
    if (!event.start) {
      return this.errors.log('FullCalendar: Event start not provided to updateNoteTime');
    }
    const date = _classPrivateMethodGet(this, _getDateWithTimeZone, _getDateWithTimeZone2).call(this, event.start);
    this.calendarNote.update(event.id, date.unix());
  }
  function _trackSchedulingPost2(type, mediaTypeCount) {
    const {
      image,
      video
    } = mediaTypeCount;
    this.segment.track('started-scheduling-post', {
      area: 'dragged_from_side_library_to_calendar',
      type,
      is_multi_profile: this.socialProfilesSelectedForScheduling.length > 1,
      multi_profile_types: this.socialProfilesSelectedForScheduling,
      number_of_images: image ?? 0,
      number_of_videos: video ?? 0
    });
  }
  async function _updateTimeSlotTime2(event) {
    if (!event.start) {
      return this.errors.log('FullCalendar: Event start not provided to updateTimeSlotTime');
    }
    if (!this.multipleProfilesSelected) {
      const date = _classPrivateMethodGet(this, _getDateWithTimeZone, _getDateWithTimeZone2).call(this, event.start);
      await this.calendarTimeSlot.update(event.id, date);
      this.updateEvents();
    }
  }
  function _updateBttp2() {
    this.bttp.autoEnableBttp.perform();
  }
  function _updateSelectPostButtons2() {
    const createLinkButton = document.querySelector('.fc-createLink-button');
    const cancelButton = document.querySelector('.fc-cancel-button');
    const sendPostsButton = document.querySelector('.fc-sendPosts-button');
    const selectAllButton = document.querySelector('.fc-selectAll-button');
    sendPostsButton?.classList.add('cSP--sendPostsButton');
    cancelButton?.classList.add('cSP--sendPostsButton');
    selectAllButton?.classList.add('cSP--selectAllButton');
    if (createLinkButton) {
      // TODO: add share icon to createLink button
      // const createButtonText = this.intl.t('calendar.share_posts.create_link', { count: this.selectedPosts.size });
      // createLinkButton.innerHTML = `${this.shareSvg} ${createButtonText}`;
      createLinkButton?.classList.add('cSP--createLinkButton');
      if (this.selectedPosts.size === 0) {
        createLinkButton?.classList.add('o--btn--disabled');
      } else {
        createLinkButton?.classList.remove('o--btn--disabled');
      }
    }
    this.fullCalendar?.setOption('customButtons', this.customButtons);
  }
  function _showStoriesAlert2() {
    this.alerts.info(this.intl.t('alerts.calendar.send_posts_stories.message'), {
      sticky: true,
      title: this.intl.t('alerts.calendar.send_posts_stories.title')
    });
    this.cache.add(this.storiesAlertKey, true, {
      expiry: this.cache.maxExpiryDate(),
      persist: true
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FullCalendarComponent);
});